import { useCallback, useEffect, useRef } from 'react';
import { useBeforeUnload, useBlocker } from 'react-router-dom';

export function useDirtyNavigationGuard(dirty, discardDraft, locked = false) {
  const allowNext = useRef(false);
  const shouldBlock = useCallback(() => (dirty || locked) && !allowNext.current, [dirty, locked]);
  const blocker = useBlocker(shouldBlock);
  useBeforeUnload((event) => {
    if (!dirty && !locked) return;
    event.preventDefault();
    event.returnValue = '';
  });
  useEffect(() => {
    if (locked && blocker.state === 'blocked') blocker.reset();
  }, [blocker, locked]);

  return {
    pending: !locked && blocker.state === 'blocked',
    cancel: () => { if (blocker.state === 'blocked') blocker.reset(); },
    confirm: () => {
      if (blocker.state !== 'blocked') return;
      discardDraft();
      blocker.proceed();
    },
    allowNextNavigation: () => {
      allowNext.current = true;
      window.setTimeout(() => { allowNext.current = false; }, 0);
    },
  };
}

export function usePendingNavigationLock(locked) {
  const blocker = useBlocker(locked);
  useBeforeUnload((event) => {
    if (!locked) return;
    event.preventDefault();
    event.returnValue = '';
  });
  useEffect(() => {
    if (blocker.state === 'blocked') blocker.reset();
  }, [blocker]);
}
